import financeActivityTypes from 'constants/finance-activity-types';

export function convertParticipantsToContacts(participants) {

  const contacts = [];

  for (let participant of participants) {

    contacts.push({
      name: participant.fullName,
      value: participant.email,
      startupUserId: participant._id,
      _id: participant._id,
      profilePicture: participant.profilePicture,
      metadata: {
        status: participant.status
      }
    });

  }

  return contacts;

}

function setStartupUser(activity, startupUsersMap) {

  let startupUser = startupUsersMap[activity.startupUserId] || null;

  if (startupUser === null) {
    startupUser = {
      fullName: 'Site Visitor',
      profilePicture: {
        url: process.env.REACT_APP_ASSETS_URL + '/assets/images/default-profile-picture.png'
      }
    };
    return;
  }

  startupUser.fullName = startupUser.fullName || startupUser.email || `Visitor: ${startupUser._id.substring(0, 6)}`;

  activity.startupUser = startupUser;

}

function formatMarketOrderActivity(activity, marketOrder) {

  activity.price = 0;
  activity.currency = 'USD';

  try {

    const checkoutSession = marketOrder.checkoutSession || null;

    let price = 0;

    if (checkoutSession === null) {
      price = marketOrder.marketProducts[0].price.unitAmount / 100;
    } else {
      price = checkoutSession.amount_total;
    }

    activity.price = price / 100;
    activity.currency = marketOrder.marketProducts[0].price.currency;

  } catch (exception) {

    // eslint-disable-next-line no-console
    console.error(exception);

  }

}

function formatInvoiceActivity(activity, invoice) {

  if (invoice.metadata === void 0) {
    activity.price = 0;
    activity.currency = 'USD';
    return;
  }

  activity.price = (invoice.metadata.stripeInvoice.amount_due || 0) / 100;
  activity.currency = invoice.metadata.stripeInvoice.currency || 'USD';

}

function formatPayoutActivity(activity, payout) {

  activity.price = (payout.amount || 0) / 100;
  activity.currency = payout.currency || 'USD';

}

function setPriceAndCurrency(activity, dataMap) {

  const data = dataMap[activity.dataId] || null;

  if (data === null) {
    return;
  }

  activity.status = data.status;

  if (activity.type === financeActivityTypes.MARKET_ORDER) {
    formatMarketOrderActivity(activity, data);
  } else if (activity.type === financeActivityTypes.INVOICE) {
    formatInvoiceActivity(activity, data);
  } else if (activity.type === financeActivityTypes.PAYOUT) {
    formatPayoutActivity(activity, data);
  }

  activity.price = activity.price.toLocaleString();

}

export function formatActivities(activities, startupUsersMap, dataMap) {

  for (let activity of activities) {

    activity.entity = dataMap[activity.dataId];

    setStartupUser(activity, startupUsersMap);

    setPriceAndCurrency(activity, dataMap);

  }

  return activities;

}

export function formatActivity(activity, startupUserMap, dataMap) {

  return formatActivities([activity], startupUserMap, dataMap)[0];

}